import { render, staticRenderFns } from "./CompanyThumb.vue?vue&type=template&id=6e2b4c93&scoped=true&"
import script from "./CompanyThumb.vue?vue&type=script&lang=js&"
export * from "./CompanyThumb.vue?vue&type=script&lang=js&"
import style0 from "./CompanyThumb.vue?vue&type=style&index=0&id=6e2b4c93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2b4c93",
  null
  
)

export default component.exports